import { Env, readFromEnv } from '@cinch-nx/environments'
import { getNaturalLanguageQueryFromUrlPath } from '../get-natural-language-query-from-url-path/get-natural-language-query-from-url-path'
import { stripNonSearchQueryParametersFromUrl } from '../strip-non-search-query-parameters-from-url/strip-non-search-query-parameters-from-url'

export const getUsedCarsApiRequestUrlForUrlPath = (urlPath: string) => {
  const urlWithoutLeadingSlash = urlPath.startsWith('/')
    ? urlPath.slice(1)
    : urlPath

  const naturalLanguageQuery = getNaturalLanguageQueryFromUrlPath(urlPath)

  const urlWithNonSearchParamsRemoved = stripNonSearchQueryParametersFromUrl(
    urlWithoutLeadingSlash,
  )
  const searchServiceUrl = readFromEnv(Env.SearchServiceUrl)
  const baseUrl = `${searchServiceUrl}/used-cars?url=${encodeURIComponent(
    urlWithNonSearchParamsRemoved,
  )}`

  return naturalLanguageQuery
    ? `${baseUrl}&q=${encodeURIComponent(naturalLanguageQuery)}`
    : baseUrl
}
